<template>
  <div class="text-xs-left">
    <v-menu offset-x :close-on-content-click="false" :nudge-width="200" v-model="menu">
      <v-btn color="indigo" flat slot="activator">
        <v-icon>filter_list</v-icon>
      </v-btn>
      <v-card>
        <v-list>
          <v-list-tile>
            <v-list-tile-action>
              <v-menu
                lazy
                :close-on-content-click="false"
                v-model="menu3"
                ref="menu3"
                transition="scale-transition"
                offset-y
                full-width
                :nudge-right="40"
                max-width="290px"
                min-width="290px"
              >
                <v-text-field
                  slot="activator"
                  label="Exacte datum"
                  v-model="filterDate"
                  clearable
                  prepend-icon="event"
                  readonly
                ></v-text-field>
                <v-date-picker
                  v-model="filterDate"
                  no-title
                  scrollable
                  actions
                  locale="nl"
                  @change="$refs.menu3.save(filterDate); setAllFilter()"
                >
                  <template slot-scope="{ save, cancel }">
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn flat color="primary" @click="menu3 = false">Annuleren</v-btn>
                    </v-card-actions>
                  </template>
                </v-date-picker>
              </v-menu>
            </v-list-tile-action>
          </v-list-tile>
          <v-list-tile>
            <v-list-tile-action>
              <v-menu
                lazy
                :close-on-content-click="false"
                v-model="menu1"
                ref="menu1"
                transition="scale-transition"
                offset-y
                full-width
                :nudge-right="40"
                max-width="290px"
                min-width="290px"
              >
                <v-text-field
                  slot="activator"
                  label="Startdatum >"
                  clearable
                  v-model="startDate"
                  prepend-icon="event"
                  readonly
                ></v-text-field>
                <v-date-picker
                  v-model="startDate"
                  no-title
                  scrollable
                  actions
                  locale="nl"
                  @change="$refs.menu1.save(startDate)"
                >>
                  <template slot-scope="{ save, cancel }">
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn flat color="primary" @click="menu1 = false">Annuleren</v-btn>
                    </v-card-actions>
                  </template>
                </v-date-picker>
              </v-menu>
            </v-list-tile-action>
          </v-list-tile>
          <v-list-tile>
            <v-list-tile-action>
              <v-menu
                lazy
                ref="menu2"
                :close-on-content-click="false"
                v-model="menu2"
                transition="scale-transition"
                offset-y
                full-width
                :nudge-right="40"
                max-width="290px"
                min-width="290px"
              >
                <v-text-field
                  slot="activator"
                  label="Einddatum <"
                  clearable
                  v-model="endDate"
                  prepend-icon="event"
                  readonly
                ></v-text-field>
                <v-date-picker
                  v-model="endDate"
                  no-title
                  scrollable
                  actions
                  @change="$refs.menu2.save(endDate)"
                >>
                  <template slot-scope="{ save, cancel }">
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn flat color="primary" @click="menu2 = false">Annuleren</v-btn>
                    </v-card-actions>
                  </template>
                </v-date-picker>
              </v-menu>
            </v-list-tile-action>
          </v-list-tile>
          <v-list-tile>
            <v-list-tile-action>
              <v-switch v-model="open" color="green darken-3"></v-switch>
            </v-list-tile-action>
            <v-list-tile-title>Toon alleen openstaande</v-list-tile-title>
          </v-list-tile>
        </v-list>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn flat @click="menu = false">Annuleren</v-btn>
          <v-btn color="primary" flat @click="setFilter()">Filter</v-btn>
        </v-card-actions>
      </v-card>
    </v-menu>
  </div>
</template>
<script>
import * as utils from "@/utils/utils";
import moment from "moment";
export default {
  name: "HistoryFilter",
  data: () => ({
    open: true,
    menu: false,
    filterDate: "",
    startDate: "",
    endDate: "",
    filterDateFormatted: "",
    startDateFormatted: "",
    endDateFormatted: "",
    menu1: false,
    menu2: false,
    menu3: false
  }),
  watch: {
    startDate(newVal) {
      if (newVal) {
        this.filterDate = "";
        this.startDateFormatted = moment(newVal).format("YYYY-MM-DD 00:00:00");
      } else {
        this.startDateFormatted = "";
      }
    },
    endDate(newVal) {
      if (newVal) {
        this.filterDate = "";
        this.endDateFormatted = moment(newVal).format("YYYY-MM-DD 23:59:59");
      } else {
        this.endDateFormatted = "";
      }
    },
    filterDate(newVal) {
      if (newVal) {
        this.startDate = "";
        this.endDate = "";
        this.filterDateFormatted = moment(newVal).format("YYYY-MM-DD 23:59:59");
      } else {
        this.filterDateFormatted = "";
      }
    }
  },
  methods: {
    setFilter() {
      this.$emit("setFilter", {
        open: this.open,
        filterDate: this.filterDateFormatted,
        startDate: this.startDateFormatted,
        endDate: this.endDateFormatted
      });
      this.menu = false;
    },
    setAllFilter() {
      this.open = null;
    }
  }
};
</script>




// WEBPACK FOOTER //
// src/components/History/HistoryFilter.vue